import React,{useState,useContext} from 'react';

import { makeStyles } from '@material-ui/core/styles';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import List from '@material-ui/core/List';
import Link from '@material-ui/core/Link';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Divider from '@material-ui/core/Divider';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';

import {Link as RouterLink} from "react-router-dom";

import _appContext from '../../contexts/appContext';

import { auth } from '../../utils/firebase';

import PropTypes from 'prop-types';

import loadData from '../../utils/dataFiller';

const useStyles = makeStyles({
  list: {
    width: 250,
  },
  fullList: {
    width: 'auto',
  },
  gutterTop: {
      marginTop: '15px'
  }
});

const links = [
    {
        url: '/users',
        text: 'Пользователи',
        roles: ['admin']
    },
    {
        url: '/planets',
        text: 'Планеты',
        roles: ['admin']
    },
    {
        url: '/streams',
        text: 'Стримы',
        roles: ['streamer', 'admin']
    },
    {
        url: '/auto-stream-tracks',
        text: 'Треки автостримов',
        roles: ['streamer', 'admin']
    },
    {
        url: '/admins',
        text: 'Стримеры и админы',
        roles: ['admin']
    },
    {
        url: '/chat',
        text: 'Чат',
        roles: ['admin']
    },
    {
        url: '/notifications',
        text: 'Уведомления',
        roles: ['admin']
    },
    {
        url: '/tracks',
        text: 'Список треков в приложении',
        roles: ['admin']
    },
    {
        url: '/promocodes',
        text: 'Промокоды',
        roles: ['admin']
    },
    {
        url: '/tips',
        text: 'Помощь',
        roles: ['admin']
    },
    {
        url: '/languages',
        text: 'Языки',
        roles: ['admin']
    },
]

export default function CustomDrawer({state, toggleDrawer}) {
    const [loadJSONDialogStatus, setLoadJSONSDialogtatus] = useState(false);
    const [JSONfile, setJSONfile] = useState({});

    const appContext = useContext(_appContext);

    const classes = useStyles();

    const handleCloseLoadJSONDialog = () => {
        setJSONfile({});
        setLoadJSONSDialogtatus(false);
    };


    const handleAddJSONFile = (event) => {
        const file = event.target.files[0];

        setJSONfile(file);

    }

    const openLoadJSONDialog = (event) => {
        setLoadJSONSDialogtatus(true);
    }

    const handleLoadJSONData = async () => {
        const reader = new FileReader();

        reader.onload = (readerEvent) => {
            try {
                const responce = loadData(JSON.parse(readerEvent.target.result));
                appContext.snackbar.showSnackbarMsg(responce.message);
            } catch (err) {
                appContext.snackbar.showSnackbarMsg("Некорректный json");
            }
        }

        reader.readAsText(JSONfile);
        handleCloseLoadJSONDialog();

    }

    return (
        <div>
            <SwipeableDrawer
                onClose={toggleDrawer}
                onOpen={() => null}
                open={state}
            >
                <div
                    role="presentation"
                    onClick={toggleDrawer}
                    onKeyDown={toggleDrawer}
                >
                    <List>
                        {
                            links
                            .filter(link => link.roles.includes(auth().currentUser.role))
                            .map(link => (
                                <Link component={RouterLink} to={link.url} id={link.url} key={link.url}>
                                    <ListItem button>
                                        <ListItemText primary={link.text} />
                                    </ListItem>
                                </Link>
                            ))
                        }
                    </List>
                    <Divider />
                    <List>
                        <ListItem button>
                            <ListItemText primary="Загрузка данные из JSON" onClick={openLoadJSONDialog}/>
                        </ListItem>
                    </List>
                </div>
            </SwipeableDrawer>
            <Dialog
                onClose={handleCloseLoadJSONDialog}
                aria-labelledby="simple-dialog-title"
                open={loadJSONDialogStatus}
                maxWidth="sm"
                fullWidth={true}
            >
                <DialogTitle>Загрузка данных в базу</DialogTitle>
                <DialogContent>
                    <label htmlFor="upload-photo">
                        <input
                            style={{ display: 'none' }}
                            id="upload-photo"
                            name="upload-photo"
                            type="file"
                            onChange={handleAddJSONFile}
                            accept='.json'
                        />

                        <Button color="secondary" variant="contained" component="span">
                            Выберите json файл
                        </Button>

                    </label>
                    <Typography variant="subtitle1" gutterBottom className={classes.gutterTop}>
                        {JSONfile.name || ''}
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseLoadJSONDialog} color="primary">
                        Отмена
                    </Button>
                    <Button onClick={handleLoadJSONData} color="primary">
                        Сохранить
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}

CustomDrawer.propTypes = {
    state: PropTypes.bool,
    toggleDrawer: PropTypes.func
};
